import { doc, updateDoc } from "firebase/firestore";
import { db } from "../config/firebase";
import { store } from "../store";
import {
  updateActivityInStore,
  updateActivityNotesInStore,
} from "../store/profileSlice";

// Update activity review and rating
export const updateActivityReview = async (
  activityId: string,
  updateData: {
    expertRating?: number;
    expertReview?: string;
    customerRating?: number;
    customerReview?: string;
    updatedAt?: Date;
  }
) => {
  try {
    // Reference to the sessionActivity document
    const sessionActivityRef = doc(db, "sessionActivity", activityId);

    // Update the activity in sessionActivity collection
    await updateDoc(sessionActivityRef, updateData);

    // Update the Redux store
    store.dispatch(updateActivityInStore({ activityId, ...updateData }));

    console.log("Activity review updated in Firebase:", updateData);
    return { success: true };
  } catch (error) {
    console.error("Error updating activity review:", error);
    return {
      success: false,
      error: error instanceof Error ? error.message : "Unknown error occurred",
    };
  }
};

// Add note to activity
export const addNoteToActivity = async (
  activityId: string,
  notes: Array<{ id: number; text: string; timestamp: string }>
) => {
  try {
    // Reference to the sessionActivity document
    const sessionActivityRef = doc(db, "sessionActivity", activityId);

    // Ensure each note has a unique ID by using timestamp if not already set
    const notesWithUniqueIds = notes.map((note) => {
      // If the note doesn't have an ID or has a potentially duplicate ID (like array index)
      if (!note.id || note.id === 0) {
        return {
          ...note,
          id: Date.now() + Math.floor(Math.random() * 1000), // Create unique ID with timestamp + random number
        };
      }
      return note;
    });

    // Update the adminNotes field in the sessionActivity collection
    await updateDoc(sessionActivityRef, {
      adminNotes: notesWithUniqueIds,
      updatedAt: new Date(),
    });

    // Update the Redux store
    store.dispatch(
      updateActivityNotesInStore({ activityId, adminNotes: notesWithUniqueIds })
    );

    console.log("Admin note added successfully");
    return { success: true };
  } catch (error) {
    console.error("Error adding admin note:", error);
    return {
      success: false,
      error: error instanceof Error ? error.message : "Unknown error occurred",
    };
  }
};

// Update activity notes
export const updateActivityNotes = async (
  activityId: string,
  notes: Array<{ id: number; text: string; timestamp: string }>
) => {
  try {
    // Reference to the sessionActivity document
    const sessionActivityRef = doc(db, "sessionActivity", activityId);

    // Update the adminNotes field in the sessionActivity collection
    await updateDoc(sessionActivityRef, {
      adminNotes: notes,
      updatedAt: new Date(),
    });

    // Update the Redux store
    store.dispatch(
      updateActivityNotesInStore({ activityId, adminNotes: notes })
    );

    console.log("Activity notes updated successfully");
    return { success: true };
  } catch (error) {
    console.error("Error updating activity notes:", error);
    return {
      success: false,
      error: error instanceof Error ? error.message : "Unknown error occurred",
    };
  }
};
